// extracted by mini-css-extract-plugin
export default {"container":"Deals_container__4eJGO","containerCard":"Deals_containerCard__GusDP","card":"Deals_card__YkXOd","cardpro":"Deals_cardpro__hOm6L"};